export function transformSecurity(value: number) {
  const grades = [
    'A+',
    'A',
    'A-',
    'B+',
    'B',
    'B-',
    'C+',
    'C',
    'C-',
    'D+',
    'D',
    'D-',
    'E',
  ]

  const input = Math.max(1, Math.min(10, value))
  const index = Math.round(((10 - input) / 9) * (grades.length - 1))

  return grades[index]
}
